import { useCallback } from 'react';
import { useHistory } from '@shared/core';
import { getSlugFromPathname } from '@apps/guest/packages/layout-engine/common/utils/getPageInfo';
import type { PagesRefs } from '@apps/guest/packages/layout-engine/layouts/LayoutAloha/LayoutAloha.types';
import type { EventPageFragment } from '@graphql/fragments/event.page.graphql.generated';
import { EventPageType } from '@graphql/generated-base';
import { useDefaultPage } from '@shared/hooks/useDefaultPage';

export const usePageRefFromUrl = (pages?: ReadonlyArray<EventPageFragment>) => {
  const history = useHistory();
  const { defaultPage } = useDefaultPage(pages);

  const getPageRefFromUrl = useCallback(
    (pagesRef: ReadonlyArray<PagesRefs>) => {
      const { pagePath: slugFromPathname, isCustomPagePath } = getSlugFromPathname(history.location.pathname);

      // If no slug in URL (root route), return the default page ref
      if (!slugFromPathname && defaultPage) {
        return pagesRef.find(pageRef => pageRef.page.pageSlug === defaultPage.pageSlug);
      }

      const currentPage = pagesRef.find(
        pageRef => slugFromPathname && pageRef.page.pageSlug.toLowerCase() === slugFromPathname?.toLowerCase() && (!isCustomPagePath || pageRef.page.type === EventPageType.custom),
      );
      return currentPage;
    },
    [history.location, defaultPage],
  );

  return getPageRefFromUrl;
};
